// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2sRpn","emails":"CreateEditClinics_emails__3hsEU","emailTagLabel":"CreateEditClinics_emailTagLabel__3bYec"};